module.exports = __webpack_public_path__ + "static/channels-xl-4469447469a7fdbcc1246ec940253430.svg";